var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.show, title: "修改日志" },
      on: { close: _vm.handleClose, open: _vm.handleOpen }
    },
    [
      _c(
        "el-table",
        { attrs: { border: "", data: _vm.list, size: "mini", height: "700" } },
        [
          _c("el-table-column", {
            attrs: { label: "更新类型", prop: "type_formal" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "更新人", prop: "update_admin" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "更新时间", prop: "updated_at" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "更新文件" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.file_url
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-download" },
                            on: {
                              click: function($event) {
                                return _vm.handleDownload(row)
                              }
                            }
                          },
                          [_vm._v("下载文件")]
                        )
                      : _c("span", [_vm._v("/")])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af650aa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af650aa6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/ShippingRule/components/ChangeLogDialog.vue
// module id = null
// module chunks = 